<template>
  <div class="stats-page">
    <el-card class="box-card">
      <!-- 搜索工具栏 -->
      <div class="search-toolbar">
        <el-form :inline="true" :model="searchForm" class="demo-form-inline">
          <el-form-item label="投保人公司">
            <el-input v-model="searchForm.companyName" placeholder="投保人公司名称" clearable></el-input>
          </el-form-item>
          <el-form-item label="保单号">
            <el-input v-model="searchForm.policyNo" placeholder="保单号" clearable></el-input>
          </el-form-item>
          <el-form-item label="时间">
            <el-date-picker v-model="searchForm.dateRange" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="timestamp"></el-date-picker>
          </el-form-item>
          <el-form-item label="手机号">
            <el-input v-model="searchForm.mobile" placeholder="手机号" clearable></el-input>
          </el-form-item>
          <el-form-item label="被保险人">
            <el-input v-model="searchForm.beneficiary" placeholder="被保险人" clearable></el-input>
          </el-form-item>
          <el-form-item label="价格方案">
            <el-autocomplete
              v-model="searchForm.priceName"
              :fetch-suggestions="queryPriceName"
              placeholder="价格方案"
              clearable
              style="width: 200px;"
              @select="handlePriceSelect"
            >
              <template slot-scope="{ item }">
                <div>{{ item.name }}</div>
              </template>
            </el-autocomplete>
          </el-form-item>
          <el-form-item label="订单ID">
            <el-input v-model="searchForm.orderId" placeholder="订单ID" clearable></el-input>
          </el-form-item>

          <!-- 退款筛选与渠道商选择（参考老项目） -->
          <el-form-item>
            <el-checkbox v-model="onlyRefund">查询退款订单</el-checkbox>
          </el-form-item>
          <el-form-item label="渠道商：">
            <el-autocomplete
              v-model="searchForm.channel"
              :fetch-suggestions="queryChannel"
              placeholder="渠道商"
              clearable
              style="width: 200px;"
              @select="handleChannelSelect"
            >
              <template slot-scope="{ item }">
                <div>{{ item.realname }} {{ item.alias ? '(' + item.alias + ')' : '' }}</div>
              </template>
            </el-autocomplete>
          </el-form-item>

          <el-form-item>
            <el-button type="primary" @click="handleSearch">搜索</el-button>
            <el-button @click="handleReset">重置</el-button>
            <el-button type="success" @click="handleExportExcel">导出Excel</el-button>
          </el-form-item>
        </el-form>
      </div>

      <div class="sum-bar">
        <strong>投保总额：<span style="color: #ff7300">{{ sum | money }}</span> 元</strong>
      </div>

      <!-- 数据表格 -->
      <el-table :data="tableData" style="width: 100%" border v-loading="loading">
        <el-table-column prop="order_id" label="订单ID" width="100" align="center"></el-table-column>
        <el-table-column prop="company_name" label="投保人" width="280" align="center"></el-table-column>
        <el-table-column prop="beneficiary" label="被保险人" width="240" align="center"></el-table-column>
        <el-table-column prop="mobile" label="手机号" width="130" align="center"></el-table-column>
        <el-table-column prop="channel_name" label="渠道" width="190" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.channel_name">{{ scope.row.channel_name }}({{ scope.row.alias }})</span>
            <span v-else>{{ scope.row.alias }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="top_channel_name" label="顶级渠道名称" width="180" align="center"></el-table-column>
        <el-table-column prop="price_name" label="价格方案" width="160" align="center"></el-table-column>
        <el-table-column prop="policy_no" label="保单号" width="180" align="center"></el-table-column>
        <el-table-column prop="source_desc" label="来源" width="180" align="center"></el-table-column>
        <el-table-column prop="amount" label="金额(元)" width="100" align="right" :formatter="amountFormat"></el-table-column>
        <el-table-column prop="balance" label="余额(元)" width="120" align="right" :formatter="moneyFormat"></el-table-column>
        <el-table-column prop="type" label="类型" width="80" align="center" :formatter="typeFormat"></el-table-column>
        <el-table-column prop="created_at" label="投保时间" width="160" align="center" :formatter="dateFormat"></el-table-column>
        <el-table-column prop="effected_at" label="起保时间" width="160" align="center" :formatter="dateFormat"></el-table-column>
        <el-table-column prop="expired_at" label="终保时间" width="160" align="center" :formatter="dateFormat"></el-table-column>
      </el-table>
    </el-card>
  </div>
</template>

<script>
import axios from '@/lib/request'
import { getToken } from '@/lib/local'
import ExportJsonExcel from 'js-export-excel'

export default {
  name: 'AppointmentFreightInsuranceStats',
  data() {
    return {
      loading: false,
      tableData: [],
      sum: 0,
      searchForm: {
        companyName: '',
        policyNo: '',
        dateRange: [],
        mobile: '',
        beneficiary: '',
        priceName: '',
        orderId: '',
        channel: '',
        appName: ''
      },
      onlyRefund: false,
      channelList: [],
      selectedChannel: null,
      appList: [],
      selectedApp: null,
      priceList: []
    }
  },
  created() {
    this.fetchData()
    this.fetchSum()
  },
  methods: {
    buildParams() {
      const params = { product_alias: 'hyx' }
      // 统计页不需要按角色强制过滤 insurance_type，老项目未传该参数

      if (this.searchForm.companyName) params.company_name = this.searchForm.companyName
      if (this.searchForm.policyNo) params.policy_no = this.searchForm.policyNo
      if (this.searchForm.dateRange && this.searchForm.dateRange.length === 2) {
        params.begin_date = Math.floor(this.searchForm.dateRange[0] / 1000)
        params.end_date = Math.floor(this.searchForm.dateRange[1] / 1000)
      }
      if (this.searchForm.mobile) params.mobile = this.searchForm.mobile
      if (this.searchForm.beneficiary) params.beneficiary = this.searchForm.beneficiary
      if (this.searchForm.priceName) params.price_name = this.searchForm.priceName
      if (this.searchForm.orderId) params.order_id = Number(this.searchForm.orderId)
      // 退款筛选（参考老项目）
      params.only_refund = !!this.onlyRefund
      // 渠道ID（参考老项目）
      if (this.selectedChannel && this.selectedChannel.id) {
        params.channel_id = this.selectedChannel.id
      }
      // 平台（app）
      if (this.selectedApp && this.selectedApp.id) {
        params.app_id = this.selectedApp.id
      }
      return params
    },
    async fetchData() {
      this.loading = true
      try {
        const params = this.buildParams()
        const res = await axios.request({
          url: '/v1/admin/cmn/transaction/insurance/internal',
          method: 'get',
          params: { ...params, page: 1, rows: 15 },
          headers: { 'AppKey': 'BpLnfgDs' }
        })
        this.tableData = res.rows || []
        // sum 单独接口获取
      } catch (e) {
        console.error('获取投保统计失败', e)
      } finally {
        this.loading = false
      }
    },
    async fetchSum() {
      try {
        const params = this.buildParams()
        const res = await axios.request({
          url: '/v1/admin/cmn/transaction/insurance/sum',
          method: 'get',
          params,
          headers: { 'AppKey': 'BpLnfgDs' }
        })
        this.sum = Number(res.sum || 0) / 100
      } catch (e) {
        console.error('获取投保总额失败', e)
      }
    },
    handleSearch() {
      this.fetchData()
      this.fetchSum()
    },
    handleReset() {
      this.searchForm = { companyName: '', policyNo: '', dateRange: [], mobile: '', beneficiary: '', priceName: '', orderId: '', channel: '', appName: '' }
      this.onlyRefund = false
      this.selectedChannel = null
      this.selectedApp = null
      this.fetchData()
      this.fetchSum()
    },
    handleExportExcel() {
      // 参考老项目：导出时调用非 internal 接口拉取完整列表
      const params = this.buildParams()
      axios.request({
        url: '/v1/admin/cmn/transaction/insurance',
        method: 'get',
        params,
        headers: { 'AppKey': 'BpLnfgDs' }
      }).then(res => {
        const rows = res.rows || []
        const data = rows.map(r => ({
          '订单ID': r.order_id,
          '投保人': r.company_name,
          '被保险人': r.beneficiary,
          '投保时间': this.dateFormat(null, null, r.created_at),
          '保单号': r.policy_no,
          '起保时间': this.dateFormat(null, null, r.effected_at),
          '终保时间': this.dateFormat(null, null, r.expired_at),
          '金额(元)': Number(this.moneyFormat(null, null, r.amount)),
          '顶级渠道名称': r.top_channel_name,
          '渠道': r.channel_name ? `${r.channel_name}(${r.alias})` : r.alias,
          '手机号码': r.mobile,
          '价格方案': r.price_name,
          '来源': r.source_desc,
          '余额(元)': Number(this.moneyFormat(null, null, r.balance)),
          '类型': this.typeFormat(r.type)
        }))
        if (!data.length) {
          this.$message.warning('没有查询到数据')
          return
        }
        const option = {
          fileName: '预约货运险投保统计',
          datas: [{
            sheetData: data,
            sheetName: 'sheet',
            sheetHeader: ['订单ID','投保人','被保险人','投保时间','保单号','起保时间','终保时间','金额(元)','顶级渠道名称','渠道','手机号码','价格方案','来源','余额(元)','类型']
          }]
        }
        const toExcel = new ExportJsonExcel(option)
        toExcel.saveExcel()
      }).catch(err => {
        console.error('导出失败', err)
        this.$message.error('导出失败')
      })
    },
    // Element-UI formatter 签名：(row, column, cellValue)
    dateFormat(row, column, cellValue) {
      const ts = cellValue
      if (!ts && ts !== 0) return ''
      // 支持秒/毫秒/字符串
      let ms = ts
      if (typeof ts === 'number') {
        ms = ts > 1e12 ? ts : ts * 1000
      } else if (typeof ts === 'string') {
        const num = Number(ts)
        if (!isNaN(num)) ms = num > 1e12 ? num : num * 1000
        else ms = ts
      }
      const d = new Date(ms)
      if (isNaN(d.getTime())) return ''
      const y = d.getFullYear()
      const m = String(d.getMonth() + 1).padStart(2, '0')
      const day = String(d.getDate()).padStart(2, '0')
      const hh = String(d.getHours()).padStart(2, '0')
      const mm = String(d.getMinutes()).padStart(2, '0')
      const ss = String(d.getSeconds()).padStart(2, '0')
      return `${y}-${m}-${day} ${hh}:${mm}:${ss}`
    },
    moneyFormat(row, column, cellValue) {
      const v = cellValue
      if (v == null) return ''
      return (Number(v) / 100).toFixed(2)
    },
    amountFormat(row, column, cellValue) {
      const v = cellValue
      if (!row || row.type === 1) return v
      if (v > 0) return '-' + this.moneyFormat(row, column, v)
      return '+' + this.moneyFormat(row, column, Math.abs(v))
    },
    typeFormat(t) {
      if (t === 1) return '充值'
      if (t === 2) return '投保'
      if (t === 4) return '红包抵扣'
      if (t === 64) return '退款'
      return ''
    },
    // 渠道商自动完成（参考项目其他页面实现）
    async queryChannel(searchText, cb) {
      try {
        // 优先使用已有列表，避免重复请求
        if (!this.channelList.length) {
          const res = await axios.request({
            url: '/v1/admin/cmn/channel/list',
            method: 'get',
            headers: { 'AppKey': 'BpLnfgDs' }
          })
          this.channelList = res.rows || []
        }
        const text = (searchText || '').toLowerCase()
        const results = this.channelList.filter(channel => {
          const realname = (channel.realname || '').toLowerCase()
          const alias = (channel.alias || '').toLowerCase()
          return realname.includes(text) || alias.includes(text)
        })
        cb(results)
      } catch (e) {
        console.error('获取渠道列表失败', e)
        cb([])
      }
    },
    handleChannelSelect(item) {
      this.selectedChannel = item
      // 展示为名称(工号)，内部用ID
      this.searchForm.channel = item.realname + (item.alias ? `(${item.alias})` : '')
    },
    // 平台自动完成
    async queryApps(queryString, cb) {
      try {
        if (!this.appList.length) {
          const res = await axios.request({
            url: '/v1/admin/cmn/app/list',
            method: 'get',
            headers: { 'AppKey': 'BpLnfgDs' }
          })
          this.appList = res.rows || []
        }
        let results = this.appList.map(app => ({ name: app.name || app.app_name || app.id, id: app.id }))
        if (queryString) {
          const q = (queryString || '').toLowerCase()
          results = results.filter(item => String(item.name).toLowerCase().includes(q))
        }
        cb(results)
      } catch (e) {
        console.error('获取平台列表失败', e)
        cb([])
      }
    },
    handleAppSelect(item) {
      this.selectedApp = item
      this.searchForm.appName = item.name
    },
    // 价格方案自动完成（hyx价格列表）
    async queryPriceName(queryString, cb) {
      try {
        if (!this.priceList.length) {
          const res = await axios.request({
            url: '/v1/admin/hyx/price/list',
            method: 'get',
            headers: { 'AppKey': 'BpLnfgDs' }
          })
          this.priceList = res.rows || []
        }
        let results = this.priceList
        if (queryString) {
          const q = (queryString || '').toLowerCase()
          results = results.filter(item => String(item.name || '').toLowerCase().includes(q))
        }
        // 返回项包含 name 字段
        cb(results.map(r => ({ name: r.name })))
      } catch (e) {
        console.error('获取价格方案列表失败', e)
        cb([])
      }
    },
    handlePriceSelect(item) {
      this.searchForm.priceName = item.name
    }
  },
  filters: {
    money(v) { return Number(v).toFixed(2) }
  }
}
</script>

<style scoped>
.search-toolbar { margin-bottom: 10px; }
.sum-bar { margin: 8px 0; }
</style>
          <!-- 平台选择（老项目有平台列表） -->
          <el-form-item label="平台：">
            <el-autocomplete
              v-model="searchForm.appName"
              :fetch-suggestions="queryApps"
              placeholder="平台"
              clearable
              style="width: 200px;"
              @select="handleAppSelect"
            >
              <template slot-scope="{ item }">
                <div>{{ item.name }}</div>
              </template>
            </el-autocomplete>
          </el-form-item>
